import { combineReducers } from 'redux'
import ScheduleByDoctorDivisionsDatetimesReducer from './schedule.bydoctor.divisions_datetimes.reducer'
import ScheduleByDoctorDoctorsReducer from './schedule.bydoctor.doctors.reducer'

const ScheduleByDoctorReducer = combineReducers({
  doctors: ScheduleByDoctorDoctorsReducer,
  divisions_datetimes: ScheduleByDoctorDivisionsDatetimesReducer,
})

export default ScheduleByDoctorReducer